import HandleObj from "../components/Modal/HandleObj";
import { isImage } from "./index";

type val = string | number | boolean | [] | object;

type KeysToHide = string[];
const vieWbtn: ElementStyle = {
  border: "1px solid black",
  padding: "0px 12px",
  borderRadius: "5px",
  color: "rgb(49, 99, 156)",
};

type record = Record<string, val>;
const transform = (
  value: val,
  handleViewObjects?: handleObj
): React.ReactNode => {
  switch (typeof value) {
    case "string":
      if (value.includes("https:")) {
        return (
          <a href={value} target="_blank" style={{ textDecoration: "none" }}>
            {isImage(value) ? (
              <img
                src={value!}
                style={{
                  ...{ aspectRatio: "4/4", objectFit: "contain" },
                  ...vieWbtn,
                }}
                alt={value}
                width={80}
              />
            ) : (
              <span style={vieWbtn} className="viewBtn">
                {" "}
                View
              </span>
            )}
          </a>
        );
      }

      if (/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(value)) {
        return new Date(value).toLocaleString();
      }
      return value;
    case "object":
      if (Array.isArray(value)) {
        return (
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            {value.map((val) => {
              return transform(val);
            })}
          </div>
        );
      } else if (handleViewObjects) {
        return handleViewObjects(value as row);
      }
      {
        return <HandleObj obj={transformData(value as record)} />;
      }
      break;

    default:
      return value;
  }
};

export const transformData = (
  data: record,
  keysToHide?: KeysToHide,
  handleViewObjects?: handleObj
): TransformedDataProps => {
  const transformedData: TransformedDataProps = {};

  for (const [key, value] of Object.entries(data)) {
    const transformedKey = key.replace(/([a-z])([A-Z])/g, "$1 $2");
    if (!keysToHide?.includes(key)) {
      transformedData[transformedKey] = transform(value, handleViewObjects);
    }
  }

  return transformedData;
};
